import { styled } from '@aibi-ui/core';

const UserIconStyle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
  background: #5687ff;
  border-radius: 50%;
  color: #fff;
`;

const UserIcon = ({
  username,
  ...restProps
}: { username: string } & React.HTMLAttributes<HTMLDivElement>) => {
  const getUsername = () => {
    if (!username) return '用户';

    const isChinese = /^[\u4e00-\u9fa5]/.test(username);
    if (isChinese) {
      // 匹配所有中文字符，并取最后一个
      const chineseChars = username.match(/[\u4e00-\u9fa5]/g);
      return chineseChars?.[chineseChars.length - 1] || '';
    } else {
      const first = username[0] || '';
      const second = username[1] || '';
      if (/[\u4e00-\u9fa5]/.test(second)) {
        return first;
      } else {
        return first + second;
      }
    }
  };
  return <UserIconStyle {...restProps}>{getUsername()}</UserIconStyle>;
};

export default UserIcon;
